import { BASE_QUERY_PRO, ruleNewsPlus } from '../shared/configs';

const BASE = {
  ...BASE_QUERY_PRO,
  query: {
    ...BASE_QUERY_PRO.query,
    or: [{ terms: { key: 'SectionType', value: ['sustainable business'] } }],
    not: [...BASE_QUERY_PRO.query.not, ruleNewsPlus]
  }
};

const SECTION_TOP = { ...BASE, count: 2 };

const MAIN = { ...BASE, count: 4 };

const MORE_LIST = { ...BASE };

export { MAIN, SECTION_TOP, MORE_LIST };
